import React from "react";
import "./loading-mask.css";

export default function LoadingMask({ loading, text = "Aguarde...", children }) {
  return (
    <div className="loading-mask-wrapper">
      {children}
      {loading && (
        <div className="loading-mask-overlay" role="status" aria-live="polite">
          <div className="loading-mask-box">
            <div className="loading-mask-spinner" />
            <span>{text}</span>
          </div>
        </div>
      )}
    </div>
  );
}
